export default {
    'odkryj_dostep':'Descubre todas las categorías y disfruta del acceso completo.',
			'odkryj_dostep_opis':  '¡Solo un jugador paga y desbloquea el juego para ambos!',
            'kontynuuj_gre':  'Seguir jugando',
            'zacznij_od_nowa':  'Empezar de nuevo',
            'dolacz_do_gry':  'Unirse al juego',
            'prosze_czekac':  'Espere por favor',
            'zamknij':  '<i class="fa fa-times"></i> Cerrar',
            'start_gry':  "Empezar juego",
			'graj':  'Jugar',
			'wpisz_imiona_graczy':'Ingrese los nombres de los jugadores',
			'twoje_imie':'Su nombre',
			'imie_drugiego_gracza':'nombre del segundo jugador',
			'wyslij_zaproszenie':  'Enviar invitación <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia':  'Configuración de la conexión',
			'daj_drugiemu':  "Dale al otro jugador que escanee el código de abajo",
			'wpisz_imiona':  'Ingrese los nombres de ambos jugadores',
			'wpisz_rozne_imiona':  'Ingrese nombres que sean diferentes entre sí',
			'odblokowane':  'Todos los niveles han sido desbloqueados. ¡Sigue jugando!',
			'poziomy':  'Categorías',
			'rozpocznij_gre':  'Iniciar juego <i class="fas fa-chevron-right"></i>',
			'poziom1':  'Nivel 1',
			'poziom2':  'Nivel 2',
			'poziom3':  'Nivel 3',
			'oczekuje_na_druga_osobe':  'Esperando la respuesta de la otra persona',
			'oczekuje_na_druga_osobe_2':  'Esperando a la otra persona',
			'graj_dalej':  'Sigue jugando <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre':  'Termina el juego <i class="fas fa-chevron-right"></i>',
			'odpowiadaj_na_pytania':  'Responder preguntas',
			'pytanie':  'Pregunta',
			'z':'Con',
			'oczekuje_na_osobe':  'Esperando la respuesta de la otra persona',
			'wyniki_rozgrywki':  "Resultados del juego",
			'gratulacje':  "Felicidades",
			'macie_zgodnosc':  "Ustedes son compatibles",
			'znasz_grugiego_gracza':  "Conoces al otro jugador en",
			'zna_ciebie':  "te conoce en",
			'jak_odpowiadaliscie':  '<i class="fas fa-tasks"></i> Mira cómo respondiste',
			'pochwal_sie':  '<i class="fas fa-share-alt"></i> Muestra tu puntuación',
			'wasze_odpowiedzi':  "tus respuestas",
			'skanuj_kod':"Escanear código",
			'statystyka':  "Estadísticas",
			'statystyka_gry':  "Estadísticas del juego",
			'powiadom':  '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Notificar sobre nueva versión',
			'zapisalismy_cie':  'Hemos guardado su dirección de correo electrónico',
			'rozpocznij':  'Iniciar <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie':  "Llegar a conocer unos a otros",
			'jak_znasz':  "Matching Halves es un juego para parejas que pondrá a prueba qué tan bien conoces a tu pareja y qué tan bien él te conoce a ti",
			'help1':  "Ya comenzaste el juego. Si quieres continuar, presiona el botón de abajo.",
			'help2':  "Sin embargo, si quieres comenzar el juego de nuevo o con un nuevo jugador, presiona el botón de abajo",
			'help3':  "Sé el primer jugador en configurar el juego: agrega los nombres de los jugadores y haz que el segundo jugador escanee el código generado",
			'help4':  "Después de que el primer jugador genere el código, presiona el botón de abajo y escanea el código",
			'help5':  "Después de ingresar los nombres de los jugadores, presione el botón \"Enviar invitación\" y haga que el otro jugador escanee el código generado",
			'help6':  "Dale al otro jugador que escanee el código de abajo",
			'help7':  "Escanear el código generado por el otro jugador",
			'kup':  "Comprar",
			'zagraj_ponownie':  '<i class="fas fa-play" style="right:auto; left: 15px"></i> Reproducir de nuevo',
			'opis_gry':  'Descripción del juego',
			'poziom':  'Nivel',
			'ext_desc':  '<br>Matching Halves es un juego para parejas que te permitirá probar qué tan bien conoces a tu pareja y qué tan bien él te conoce a ti.<br><br>Juegas en línea al mismo tiempo en dos dispositivos. Ambos deben descargar el juego de la tienda.<br><br>Una persona inicia el juego haciendo clic en el botón "Iniciar juego" e ingresa sus nombres.<br><br>La otra persona se une al juego haciendo clic en el botón "Unirse al juego" y escanea el código generado por la persona que inicia el juego. Después de escanear el código, a ambos jugadores se les mostrará el inicio del juego y las categorías.<br><br>La aplicación tiene 6 categorías, cada una con 3 niveles de dificultad. Comienzas con el nivel más fácil, es decir, el nivel 1 (completar el nivel 1 te permite comenzar el siguiente).<br><br>No te desanimes con preguntas aparentemente simples, porque cuanto más te adentres en el bosque, será más difícil ¡y más picante!<br><br>W al mismo tiempo, aparecerá la misma pregunta en sus teléfonos o tabletas, a la que responda sí / no o marque una respuesta específica. Tu tarea es solo hacer clic en la respuesta correcta.<br><br>Primero respondes lo que piensa tu compañero, luego respondes por ti mismo lo que piensas. Después de cada nivel, puedes comprobar cómo respondiste y qué porcentaje obtuviste.<br><br>Puedes detener el juego en cualquier momento y terminarlo más tarde, pero si vuelves a iniciar el juego, tus respuestas anteriores se borrarán.<br> <br>¡Diviértete! <br><br><br><br><br><br>',
			'druga_osoba_odpowiedziala':  'La otra persona está esperando tu respuesta',
			'confirm_text_1':  '¿Quieres empezar el juego de nuevo?',
			'confirm_text_2':  'Perderás tus respuestas anteriores.',
			'yes_button':  '<i class="fa fa-check"></i> Sí, estoy empezando de nuevo',
			'no_button':  '<i class="fa fa-times"></i> No, todavía estoy jugando',
			'back':  '<i class="fas fa-chevron-left"></i> atrás',
			'backk':  '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Atrás',
			'podsumowanie_wynikow':  'Resumen de resultados<i class="fas fa-chevron-right"></i>',
			
			'Życie codzienne': 'La vida cotidiana',
			'Daily life': 'La vida cotidiana',
			'La vida cotidiana': 'La vida cotidiana',
			'Vie courante': 'La vida cotidiana',
			'Alltagsleben': 'La vida cotidiana',
			'Vita di ogni giorno': 'La vida cotidiana',
			'Vida cotidiana': 'La vida cotidiana',
			
			'Osobowość / charakter': 'Caracter personal',
			'Personalità/carattere': 'Caracter personal',
			'Personality / character': 'Caracter personal',
			'Caracter personal': 'Caracter personal',
			'Caractère de la personnalité': 'Caracter personal',
			'Personalidade / personagem': 'Caracter personal',
			'Persönlichkeit Charakter': 'Caracter personal',
			
			'Życie towarzyskie': 'Vida social',
			'Social life': 'Vida social',
			'Vida social': 'Vida social',
			'Vie sociale': 'Vida social',
			'Soziales Leben': 'Vida social',
			'Vita sociale': 'Vida social',
			
			'Wyznawane wartości': 'Valores propugnados',
			'Values / beliefs': 'Valores propugnados',
			'Valores propugnados': 'Valores propugnados',
			'Valeurs adoptées': 'Valores propugnados',
			'Valores expostos': 'Valores propugnados',
			'Vertraute Werte': 'Valores propugnados',
			'Valori sposati': 'Valores propugnados',
			
			'Nałogi / nawyki': 'Adicciones / hábitos',
			'Habits / Addictions': 'Adicciones / hábitos',
			'Adicciones / hábitos': 'Adicciones / hábitos',
			'Dépendances / habitudes': 'Adicciones / hábitos',
			'Vícios / hábitos': 'Adicciones / hábitos',
			'Süchte / Gewohnheiten': 'Adicciones / hábitos',
			'Dipendenze/abitudini': 'Adicciones / hábitos',
			
			'Seks':'Sexo',
			'Sex':'Sexo',
			'Sexo':'Sexo',
			'Sexe':'Sexo',
			'Sesso':'Sexo',
			
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',

			'jasny': 'Claro',
			'ciemny': 'Oscuro',
			'blad_polaczenia': "Error de conexión. Inténtalo de nuevo.",
			'przekaz_kod_gry': "Tu código de juego",
			'przekaz_kod_gry_drugi_gracz': "También puedes proporcionar el código de juego para el segundo jugador",
			"skanuj_kod_aparatem": "Escanea el código con la cámara",
  "wpisz_kod_recznie": "Introduce el código manualmente",
  "wprowadz_kod": "Introduce el código recibido",
  "wprowadz_kod_gry": "Introduce el código del juego",
  "help8": "En el campo de abajo introduce el código de juego recibido del segundo jugador. Al introducirlo, el juego se iniciará automáticamente",
  "nieprawidlowy_kod_gry": "El código introducido no es válido",
    "powrot_do_kategorii": "Volver a las categorías"





}